/* eslint-disable */
import { httpPostObservable } from './utils';

const api = {
    getProfileForOnboard: (url, params) => httpPostObservable(url, params),
    onboardFromEmail: (url,params) => httpPostObservable(url,params)
};

export default api;
